import { GraphQLClient } from 'graphql-request'

import { requestMiddleware, responseMiddleware } from './middleware'

export type ClientRequest<Variables, Response> = {
  mutateAsync: (variables: Variables) => Promise<Response>
}

export const client = new GraphQLClient(String(process.env.API_URL), {
  requestMiddleware,
  responseMiddleware,
})
